<script>
export default {
  props: {
    user: {
      default: null,
    },
  },
  methods: {
    gotoSalesTeamDetails(id) {
      this.$router.push({name: "SalesTeamDetails", params: {id: btoa(id)}});
    },
   
  }
}
</script>

<template>
  <div v-if="user" class="shadow bordered rounded-lg p-4 relative pointer"
       @click="gotoSalesTeamDetails(user.sales_team_id)">
    <div class="d-flex justify-space-between align-center border-bottom mb-2">
      <p class="mb-1 font-semibold">
        {{ user.first_name }} {{ user.last_name }}
      </p>
      <p class="mb-1 text-sm font-medium">
        {{ user.mobile }}
      </p>
    </div>
    <v-row>
      <v-col md="4" sm="12">
        <view-image
            :image="user.profile_image"
            class="rounded-lg bordered p-2"
            width="100%"
        />
      </v-col>
      <v-col md="8" sm="12">
        <v-row>
          <v-col cols="6">
            <p class="mb-0 text-center text-sm text-dark-gray">
              Deals:
            </p>
            <p class="mb-1 text-center text-blue font-medium">
              {{ user.deals?user.deals.length:0 | numberFormatter }}
            </p>
          </v-col>
          <v-col cols="6">
            <p class="mb-0 text-center text-sm text-dark-gray">
              Sales:
            </p>
            <p class="mb-1 text-center text-blue font-medium">
              {{ user.sales?user.sales:0 | toCurrency }}
            </p>
          </v-col>
          <v-col cols="6">
            <p class="mb-0 text-center text-sm text-dark-gray">
              Revenues:
            </p>
            <p class="mb-1 text-center text-blue font-medium">
              {{ user.revenue?user.revenue:0 | toCurrency }}
            </p>
          </v-col>
          <v-col cols="6">
            <p class="mb-0 text-center text-sm text-dark-gray">
              Commission:
            </p>
            <p class="mb-1 text-center text-blue font-medium">
              {{ user.commission?user.commission:0 | toCurrency }}
            </p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss" scoped>
.city-name {
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 0 0.5rem;
  background: #112A46;
  padding: 5px;
  color: white;
  font-size: 12px;
  min-width: 70px;
  text-align: center;
}
</style>